import React from 'react'
import style from './Navbar.module.css'
function Navbar() {
  return (
    <nav className={style.navigation}>
      <div className='container'>
        <div className='d-flex justify-content-between align-items-center'>
            <div>
              <span className={style.logo}>Student Progress</span>
            </div>
            <ul className={style.nav_list + " d-md-flex"}>
              <li><a className={style.nav_a} href='/'>Home</a></li>
              <li><a className={style.nav_a} href='/'>About</a></li>
              <li><a className={style.nav_a} href='/'>Teacher</a></li>
              <li><a className={style.nav_a} href='/'>Student</a></li>
            </ul>
            <div>
              <button className={style.signin}>Sign In</button>
            </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar